import {Injectable} from '@angular/core';
import {NpInstanceService} from '../np-instance.service';
import {Router} from '@angular/router';
import {RouteName} from '../../constants/route.constants';
import {EntityName} from '../../../../lib/data/model/portal';
import {NP_ENTITY_CONFIG} from '../../constants/np-entity.constants';

@Injectable({
    providedIn: 'root'
})
export class RouteResolverService {

    constructor(private _npInstanceService: NpInstanceService, private _router: Router) {
    }

    navigate(routeName: RouteName) {
        return this._router.navigate([routeName, this._npInstanceService.instanceId]);
    }

    /**
     *  Navigating within default portal
     *  @param subRouteName: child route name
     */
    navigateToDefaultEntityRoute(subRouteName: RouteName) {
        return this._router.navigate(
            [
                this._npInstanceService.instance.defaultEntityRoute,
                this._npInstanceService.instanceId,
                subRouteName
            ]
        );
    }

    /**
     *  Navigating within default portal
     *  @param subRouteName: child route name
     */
    navigateToCurrentEntityRoute(subRouteName: RouteName) {
        return this._router.navigate(
            [
                this._npInstanceService.currentEntity.routeName,
                this._npInstanceService.instanceId,
                subRouteName
            ]
        );
    }

    setEntityAndNavigateTo(entityName: EntityName, routeName: RouteName) {
        if (NP_ENTITY_CONFIG.has(entityName) && routeName) {
            this._npInstanceService.currentEntity = NP_ENTITY_CONFIG.get(entityName);
            return this.navigateToCurrentEntityRoute(routeName);
        }
        return this._router.navigate([RouteName.NO_INSTANCE_FOUND]);
    }
}
